import {cloneDeep, forEach, forOwn, isArray, isEmpty, uniq} from 'lodash';

import {
  ContentSchema,
  KEYWORD_PROP_CONSTRAINTS_LIST_REF,
} from './auto_layout_content_schema';
import {
  LayoutSchema,
  KEYWORD_PROP_EXPAND_LAYOUT,
} from './auto_layout_layout_schema';
import {
  LayoutArrayContainerComponent,
  LayoutSingleObjectWrapperComponent,
} from './wrapper_layout_schema';
import {
  ARRAY_SCREENS_WRAPPER,
  TAB_SET_SCREENS_WRAPPER,
} from 'src/js/containers/auto_layout/auto_layout_constants';

const METADATA_SCHEMA_CONTENT = 'content';
const METADATA_SCHEMA_LAYOUT = 'layout';

export class MetadataSchema {
  static collectDataSetIdsFromComponentTree(
    layoutComponent,
    contentSchema,
    layoutSchema
  ) {
    let result = [];
    if (layoutComponent) {
      const componentItems = layoutComponent.getLayoutItems();
      if (!isArray(componentItems)) {
        // recursion
        const nextLayoutComponent = layoutSchema.getComponent(
          componentItems[KEYWORD_PROP_EXPAND_LAYOUT].$valueOf()
        );
        result = result.concat(
          MetadataSchema.collectDataSetIdsFromComponentTree(
            nextLayoutComponent,
            contentSchema,
            layoutSchema
          )
        );
      } else {
        forEach(componentItems, (item) => {
          if (item.getExpandLayout()) {
            // recursion
            const nextLayoutComponent = layoutSchema.getComponent(
              item.getExpandLayout()
            );
            result = result.concat(
              MetadataSchema.collectDataSetIdsFromComponentTree(
                nextLayoutComponent,
                contentSchema,
                layoutSchema
              )
            );
          } else {
            const contentComponent = contentSchema.getComponent(
              layoutComponent.getContentObject()
            );
            forOwn(contentComponent.getProperties(), (property) => {
              if (!isEmpty(property.getConstraints())) {
                forEach(property.getConstraints(), (constraint) => {
                  if (constraint[KEYWORD_PROP_CONSTRAINTS_LIST_REF]) {
                    result.push(constraint[KEYWORD_PROP_CONSTRAINTS_LIST_REF]);
                  }
                });
              }
            });
          }
        });
      }
    }
    return result;
  }

  static collectDataSetIds(contentSchema, layoutSchema) {
    return uniq(
      MetadataSchema.collectDataSetIdsFromComponentTree(
        layoutSchema.getCore(),
        contentSchema,
        layoutSchema
      )
    );
  }

  static initItemLayout(layoutSchema) {
    let componentLayout;
    const componentType = layoutSchema.getComponentType().toLowerCase();
    switch (componentType) {
      case ARRAY_SCREENS_WRAPPER: {
        componentLayout = new LayoutArrayContainerComponent(
          layoutSchema.getCore()
        );
        break;
      }
      case TAB_SET_SCREENS_WRAPPER: {
        break;
      }
      default: {
        componentLayout = new LayoutSingleObjectWrapperComponent(
          layoutSchema.getCore()
        );
        break;
      }
    }

    return layoutSchema.getComponent(
      componentLayout.getLayoutItems().getExpandLayout()
    );
  }

  static initItemContent(contentSchema, itemLayoutSchema) {
    return contentSchema.getComponent(itemLayoutSchema.getContentObject());
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.content = {};
    this.layout = {};
    this.itemContent = {};
    this.itemLayout = {};
    this.dataSetIds = [];
    this.loaded = false;
    if (
      this.rawData &&
      this.rawData[METADATA_SCHEMA_CONTENT] &&
      this.rawData[METADATA_SCHEMA_LAYOUT]
    ) {
      this.content = new ContentSchema(this.rawData[METADATA_SCHEMA_CONTENT]);
      this.layout = new LayoutSchema(this.rawData[METADATA_SCHEMA_LAYOUT]);
      this.itemLayout = MetadataSchema.initItemLayout(this.layout);
      this.itemContent = MetadataSchema.initItemContent(
        this.content,
        this.itemLayout
      );
      this.dataSetIds = MetadataSchema.collectDataSetIds(
        this.content,
        this.layout
      );
      this.loaded = true;
    }
  }

  clone() {
    return Object.assign(new MetadataSchema(cloneDeep(this.rawData)), this);
  }

  getContent() {
    return this.content;
  }

  getLayout() {
    return this.layout;
  }

  getItemContent() {
    return this.itemContent;
  }

  getItemLayout() {
    return this.itemLayout;
  }

  getDataSetIds() {
    return this.dataSetIds;
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {MetadataSchema};
